module.exports = __webpack_public_path__ + "img/awashbank.c4600425.png";